import { pushSnackbar } from 'FRONTEND/actions/app';
import { pickPatient } from 'FRONTEND/reducers/bookingSlice';
import { goBackToForm } from 'FRONTEND/reducers/calendarSlice';
import { createOnePatient, updateOnePatient } from 'FRONTEND/reducers/patientSlice';
import i18n from 'FRONTEND/utils/i18n';

const patientMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case createOnePatient.fulfilled.toString(): {
      const wasExpectingCreation = store.getState().patient.isExpectingCreation;
      next(action);
      if (wasExpectingCreation) {
        store.dispatch(pickPatient({ id: action.payload.patient.id }));
        store.dispatch(pushSnackbar({
          message: i18n._('Patient created.'),
          variant: 'success',
        }));
        store.dispatch(goBackToForm());
      }
      return;
    }

    case updateOnePatient.fulfilled.toString(): {
      const wasExpectingEdition = store.getState().patient.isExpectingEdition;
      next(action);
      if (wasExpectingEdition) {
        store.dispatch(pushSnackbar({
          message: i18n._('Patient updated.'),
          variant: 'success',
        }));
        store.dispatch(goBackToForm());
      }
      return;
    }

    case updateOnePatient.rejected.toString(): {
      const wasExpectingEdition = store.getState().patient.isExpectingEdition;
      next(action);
      if (wasExpectingEdition) {
        store.dispatch(pushSnackbar({
          message: i18n._('Patient was not modified, please try again.'),
          variant: 'error',
        }));
        store.dispatch(goBackToForm());
      }
      return;
    }

    default:
      return next(action);
  }
};

export default patientMiddleware;
